import styled from "styled-components";

export const Description = styled.div`
  color: #1a3458;
  display: flex;
  flex-direction: column;
  gap: 20px;

  a {
    height: 72px;
    max-width: 320px;
    border-radius: 7px;
    background-color: #1a3458;
    color: white;
    font-size: 20px;
    cursor: pointer;
    font-weight: bold;
    align-items: center;
    justify-content: center;
    display: flex;
    text-align: center;
    text-decoration: none;
    position: relative;
  }

  h1 {
    font-size: 37px;
  }

  a::before {
    position: absolute;
    content: "";
    z-index: -1;
    transform: translate(-50%, -0%);
    background: #28a137;
    width: 100%;
  }

  a::before {
    top: 5%;
    left: 60%;
    height: 100%;
    border-radius: 7px;
  }

  @media (max-width: 425px) {
    h1 {
      font-size: 25px;
    }

    a {
      width: 90%;
    }
  }
`;
